import React, { Component } from 'react'
import './styles/panel.scss'

class Panel extends Component {
    render() {
        const {
            children, cssClass, style, id, innerRef,
            onClick,
        } = this.props
        return (
            <div className={`panel ${cssClass || ''}`} style={style} id={id} ref={innerRef} onClick={onClick}>
                {children}
            </div>
        )
    }
}

export default Panel
